import React from 'react';
import { useState } from 'react';
import TextInput from '../../common/TextInput';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { productApiClient } from '../../../clients/ProductAPIClient';
import { IFetchParameters } from '../../../data/models/fetchParameter';
import Spinner, { SpinnerSize } from '../../common/Spinner/Spinner';
import { Modal } from '../../common/Modal';
import { FormatType } from '@/data/models/formatType';
import { SimpleCheckbox } from '../../common/SimpleCheckbox/SimpleCheckbox';
import './Export.scss';

interface Props {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  fetchProductParams: IFetchParameters;
  formatType: FormatType;
}

const downloadSpreadsheet = async (
  filename: string,
  fetchProductParams: IFetchParameters,
  includeTrackInfo: boolean
) => {
  const exportParams = _.clone(fetchProductParams);
  exportParams.endRow = undefined;
  exportParams.startRow = 0;
  const response = await productApiClient.export(
    exportParams,
    !includeTrackInfo
  );
  const url = window.URL.createObjectURL(new Blob([response]));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
  document.body.appendChild(link);
  link.click();
  link?.parentNode?.removeChild(link);
};

const Export = ({
  showModal,
  setShowModal,
  fetchProductParams,
  formatType,
}: Props) => {
  const { t } = useTranslation();
  const [filename, setFilename] = useState(`${formatType}Export.xlsx`);
  const [exporting, setExporting] = useState(false);
  const [includeTrackInfo, setIncludeTrackInfo] = useState(true);

  const handleExport = async () => {
    try {
      setExporting(true);
      await downloadSpreadsheet(filename, fetchProductParams, includeTrackInfo);
    } finally {
      setExporting(false);
      setShowModal(false);
    }
  };

  const closePopUp = () => {
    setShowModal(false);
  };

  const onFilenameChange = (event: any) => {
    const re = /^[a-zA-Z0-9.-]+$/;

    if (event.target.value === '' || re.test(event.target.value)) {
      setFilename(event.target.value);
    }
  };

  return (
    <Modal
      titleText={t('product.export.header')}
      submitButtonText={t('product.export.confirmText')}
      show={showModal}
      submitButtonDisabled={!filename || exporting}
      onClose={closePopUp}
      onSubmit={handleExport}
    >
      {exporting ? <Spinner cover={true} size={SpinnerSize.FullPage} /> : null}

      <div className="form-group">
        <TextInput
          labelClassName="modal-field-label"
          labelTitle={t('product.export.enterFileName')}
          handleInput={onFilenameChange}
          id="filename"
          type="text"
          value={filename}
          inputClassname="form-control"
          className=""
          maxLength={75}
        ></TextInput>
      </div>
      <div className="form-group export-checkbox-wrapper">
        <SimpleCheckbox
          text={t('product.export.includeTrackInfo')}
          checked={includeTrackInfo}
          onChange={(e) => setIncludeTrackInfo(e.target.checked)}
        />
      </div>
    </Modal>
  );
};
export default Export;
